// src/components/providers/compare-adaptex-context.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { createContext } from "react";
// src/components/providers/compare-adaptex-arms.ts
var SHOW_PROMPT = "show-prompt";
var TOGGLE_PLACEMENT = "toggle-placement";
var TICK_BOX_VISIBILITY = "tick-box-visibility";
var SHOW_PROMPT_YES = "yes";
var SHOW_PROMPT_NO = "no";
var TOGGLE_PLACEMENT_NONE = "none";
var TOGGLE_PLACEMENT_FILTERS_SHEET = "filter-sheet";
var TOGGLE_PLACEMENT_SRP = "srp";
var TICK_BOX_VISIBILITY_TRUE = "true";
var TICK_BOX_VISIBILITY_FALSE = "false";
var _obj;
// src/components/providers/compare-adaptex-context.ts
var defaultState = {
    campaignId: "",
    payloadId: "",
    arms: (_obj = {}, _defineProperty(_obj, SHOW_PROMPT, SHOW_PROMPT_NO), _defineProperty(_obj, TOGGLE_PLACEMENT, TOGGLE_PLACEMENT_NONE), _defineProperty(_obj, TICK_BOX_VISIBILITY, TICK_BOX_VISIBILITY_FALSE), _obj),
    enabled: false
};
var defaultValue = [
    defaultState,
    function() {
        return void 0;
    }
];
var CompareAdaptExContext = createContext(defaultValue);
// src/components/providers/compare-adaptex-provider.tsx
import React, { useState } from "react";
var Provider = CompareAdaptExContext.Provider;
var CompareAdaptExProvider = function(param) {
    var children = param.children;
    var value = useState(defaultState);
    return /* @__PURE__ */ React.createElement(Provider, {
        value: value
    }, children);
};
export { CompareAdaptExContext, CompareAdaptExProvider, SHOW_PROMPT, SHOW_PROMPT_NO, SHOW_PROMPT_YES, TICK_BOX_VISIBILITY, TICK_BOX_VISIBILITY_FALSE, TICK_BOX_VISIBILITY_TRUE, TOGGLE_PLACEMENT, TOGGLE_PLACEMENT_FILTERS_SHEET, TOGGLE_PLACEMENT_NONE, TOGGLE_PLACEMENT_SRP, defaultState };
//# sourceMappingURL=index.js.map